<template>
  <div class="home-page-content">
    <!-- <header-view v-if="!loading"></header-view> -->
    <header>
      <div class="content">
        <div class="logo" @click="goToHome"><img :src="logo" alt="" /></div>
        <div class="nav">
          <ul>
            <li><router-link to="/">首页</router-link></li>
            <li class="dropdown">
              <router-link to="">成果对接</router-link>
              <div class="dropdown-content">
                <router-link to="/development">开放许可专区</router-link>
                <router-link to="/achievementLibrary">科技成果库</router-link>
                <router-link to="/technicalDemand">技术需求池</router-link>
              </div>
            </li>
            <li class="dropdown multi-level">
              <router-link to="">交易中心</router-link>
              <div class="dropdown-content">
                <div class="dropdown-item with-submenu">
                  <router-link to="">专利</router-link>
                  <i class="el-icon-arrow-right"></i>
                  <div class="submenu">
                    <router-link to="/pAF_sale" class="submenu-item"
                      >待售专利资产</router-link
                    >
                    <router-link to="/achievements" class="submenu-item"
                      >专利需求求购</router-link
                    >
                    <div class="submenu-item with-submenu">
                      <router-link to="">专利许可</router-link>
                      <i class="el-icon-arrow-right"></i>
                      <div class="submenu level-3">
                        <router-link to="/openPatent">开放许可</router-link>
                        <router-link to="/paidLicense">付费许可</router-link>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="dropdown-item with-submenu">
                  <router-link to="">商标</router-link>
                  <i class="el-icon-arrow-right"></i>
                  <div class="submenu">
                    <router-link to="/trademarkSale" class="submenu-item"
                      >待售商标</router-link
                    >
                    <router-link to="/trademarkPurchase" class="submenu-item"
                      >商标需求求购</router-link
                    >
                  </div>
                </div>
              </div>
            </li>
            <li><router-link to="/cases">成功案例</router-link></li>
            <li><router-link to="/contact">联系我们</router-link></li>
          </ul>
          <!-- <div class="login">
          <li><router-link to="/login">登录/注册</router-link></li>
          <li class="success">
            <router-link to="/memberCenter"
              ><p>王萌萌</p>
              <img src="../assets/userAvatar.jpg" alt=""
            /></router-link>
          </li>
        </div> -->
          <div class="login">
            <li v-if="!isLoggedIn">
              <router-link to="/login">登录/注册</router-link>
            </li>
            <li v-else class="success">
              <router-link to="/memberCenter">
                <p>{{ contact }}</p>
                <img :src="avatar" alt="用户头像" />
              </router-link>
            </li>
          </div>
        </div>
      </div>
    </header>
    <div class="index">
      <div class="banner">
        <div class="block">
          <el-carousel height="642px" arrow="never" trigger="click">
            <el-carousel-item v-for="(item, index) in bannerList" :key="index">
              <div class="carousel-content">
                <img :src="item.image" alt="轮播图" class="carousel-image" />
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <div class="content">
        <div class="box1">
          <h1>{{ homeData.title1 }}</h1>
          <h1>{{ homeData.title2 }}</h1>
          <p>
            {{ homeData.description1 }}
          </p>
          <ul>
            <li v-for="(item, index) in homeData.item1" :key="index">
              <img :src="item.image" alt="" />
              <h1>{{ item.title }}</h1>
              <p>
                {{ item.description }}
              </p>
            </li>
          </ul>
        </div>
      </div>
      <div
        class="box2"
        :style="{
          background:
            'url(' + homeData.background_img + ') no-repeat center/cover',
        }"
      >
        <div class="content">
          <h1>{{ homeData.title3 }}</h1>
          <h1>{{ homeData.title4 }}</h1>
          <p>
            {{ homeData.description2 }}
          </p>
          <div class="database">
            <ul v-for="(item, index) in homeData.item2" :key="index">
              <li>
                <h2>{{ item.number }}</h2>
                <p>{{ item.unit }}</p>
              </li>
              <span>{{ item.tag }}</span>
            </ul>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  </div>
</template>

<script>
// import headerView from "../components/Header.vue";
import Footer from "../components/Footer.vue";
import { getHome, getWebsite, getUserInfo } from "../api/userApi";
import { mapState } from "vuex";
export default {
  components: {
    // HelloWorld,
    // headerView,
    Footer,
  },
  data() {
    return {
      isHomePage: true,
      user: "",
      bannerList: [],
      homeData: {},
      loading: true,
      logo: "",
      avatar: localStorage.getItem("cachedAvatar"),
      contact: "",
    };
  },
  async created() {
    // 获取用户信息
    this.getHome();
    // 获取用户信息
    await this.getWebsite();
    await this.getUserInfo();
    // 检查本地存储中的登录状态
    this.checkLoginStatus();
  },
  computed: {
    ...mapState(["isLoggedIn"]),
  },
  methods: {
    goToHome() {
      this.$router.push("/");
    },
    // ...mapActions(["fetchUserInfo"]),
    async getWebsite() {
      try {
        const response = await getWebsite();
        if (response.code === 1) {
          this.logo = response.data.logo;
        }
      } catch (error) {
        console.error("获取接口失败", error);
      }
    },
    async getUserInfo() {
      try {
        const response = await getUserInfo();
        console.log(response.data);
        if (response.code === 1) {
          this.account = response.data.account;
          this.avatar = response.data.avatar;
          localStorage.setItem("cachedAvatar", this.avatar);

          // 预加载图片
          new Image().src = this.avatar;
          this.company = response.data.company;
          this.contact = response.data.contact;
          localStorage.setItem("username", this.contact);
          this.email = response.data.email;
          this.id = response.data.id;
          this.qq = response.data.qq;
          this.tel = response.data.tel;
          this.wechat = response.data.wechat;
        }
      } catch (error) {
        console.error("获取接口失败", error);
      }
    },
    checkLoginStatus() {
      const token = localStorage.getItem("token");
      if (token) {
        this.$store.commit("setLoginStatus", true);
      }
    },
    async getHome() {
      try {
        this.loading = true;
        const response = await getHome();
        console.log(response.data);
        if (response.code === 1) {
          this.bannerList = response.data.banner;
          console.log(this.bannerList, "this.bannerList");

          this.homeData = response.data.home;
        }
      } catch (error) {
        console.error("获取接口失败", error);
      } finally {
        this.loading = false; // 无论成功失败，都结束加载
      }
    },
  },
};
</script>

<style scoped lang="less">
li {
  list-style: none;
}
header {
  position: relative;
  z-index: 1;
  width: 100%;
  background-color: rgba(255, 255, 255, 0.3);
  backdrop-filter: blur(51px);
  .content {
    width: 100%;
    max-width: 87.5rem;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 0;

    .logo {
      cursor: pointer;
      img {
        width: 161px;
        height: 40px;
      }
    }

    .nav {
      display: flex;
      align-items: center;
      position: relative;

      ul {
        display: flex;
        border-right: 1px solid #c6c7c8;

        li {
          position: relative;
          margin-right: 40px;

          a {
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 18px;
            color: #1c1d25;
            padding: 10px 15px;
            display: block;
            transition: all 0.3s ease;

            &:hover {
              color: #1890ff;
            }
          }

          &:last-child {
            margin-right: 30px;
          }
        }
      }

      .login {
        li {
          margin-left: 36px;

          a {
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 18px;
            color: #1c1d25;
          }
        }

        .success {
          margin-left: 30px;

          a {
            display: flex;
            align-items: center;
          }

          p {
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 18px;
            color: #1c1d25;
          }

          img {
            width: 42px;
            height: 42px;
            border-radius: 50%;
            margin-left: 10px;
          }
        }
      }
    }

    /* 下拉菜单基础样式 */
    .dropdown {
      position: relative;

      &:hover .dropdown-content {
        display: block;
        opacity: 1;
        visibility: visible;
        transform: translateY(0);
      }

      .dropdown-content {
        display: none;
        position: absolute;
        top: 100%;
        left: 0;
        background-color: #fff;
        min-width: 200px;
        box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
        border-radius: 4px;
        z-index: 100;
        opacity: 0;
        visibility: hidden;
        transform: translateY(10px);
        transition: all 0.3s ease;
        padding: 8px 0;

        a {
          color: #333;
          padding: 10px 16px;
          display: block;
          font-size: 16px;

          &:hover {
            background-color: #f5f5f5;
            color: #1890ff;
          }
        }
      }

      /* 多级菜单样式 */
      &.multi-level {
        .dropdown-content {
          padding: 8px 0;
          .dropdown-item {
            position: relative;
            display: flex;
            justify-content: space-between;
            align-items: center;
            > a {
              flex: 1;
              padding-left: 32px;
            }
            > .submenu {
              display: none;
              position: absolute;
              top: -8px;
              left: 100%;
              background-color: #fff;
              min-width: 200px;
              box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
              border-radius: 4px;
              z-index: 101;
              opacity: 0;
              visibility: hidden;
              transition: all 0.3s ease;
              padding: 8px 0;
              // margin-left: 4px;
              // margin-left: 0;
              // left: calc(100% - 10px); /* 重叠10px避免间隙 */
            }

            &:hover > .submenu {
              display: block;
              opacity: 1;
              visibility: visible;
            }
          }

          .submenu-item {
            position: relative;

            &.with-submenu {
              display: flex;
              align-items: center;
              justify-content: space-between;

              > a {
                flex: 1;
              }

              i {
                padding-right: 12px;
                color: #999;
                font-size: 14px;
              }

              > .submenu {
                display: none;
                position: absolute;
                top: 0;
                left: 100%;
                background-color: #fff;
                min-width: 200px;
                box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
                border-radius: 4px;
                z-index: 102;
                opacity: 0;
                visibility: hidden;
                transition: all 0.3s ease;
                padding: 8px 0;
                // margin-left: 6px;
                // margin-left: 0;
                // left: calc(100% - 10px); /* 重叠10px避免间隙 */
              }

              &:hover > .submenu {
                display: block;
                opacity: 1;
                visibility: visible;
              }
            }
          }
        }
      }
    }
  }
}

.home-page-content {
  position: relative; // 设置相对定位，作为子元素绝对定位的参考
}
.index {
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
  .banner {
    width: 100%;
    // position: relative;
    // z-index: 0;
    .block {
      .carousel-image {
        width: 100%;
      }
      ::v-deep .el-carousel__indicators--horizontal {
        bottom: 15%;
        left: 28%;
      }
      ::v-deep .el-carousel__indicator.is-active button {
        background-color: rgba(23, 93, 194, 1);
      }
      ::v-deep .el-carousel__button {
        width: 87px;
        height: 7px;
        background: rgba(255, 255, 255, 0.4);
      }
      .carousel-content {
        position: relative;
        width: 100%;
        height: 100%;
      }
      .carousel-text {
        position: absolute;
        top: 40%;
        left: 13%;
        // transform: translate(-50%, -50%);
        text-align: left;
        color: white; /* 确保文字颜色与背景对比明显 */
        z-index: 2; /* 确保文字在图片上方 */
      }
      .carousel-text h1 {
        font-family: MiSans, MiSans;
        font-weight: 600;
        font-size: 60px;
        color: #11284c;
      }

      .carousel-text h2 {
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 28px;
        color: #11284c;
      }
    }
  }
  .content {
    width: 100%;
    max-width: 87.5rem;
    margin: 0 auto;
  }
  .box1 {
    padding: 60px 0 86px 0;
    h1 {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 30px;
      color: #1c1d25;
      text-align: center;
    }
    p {
      margin-top: 20px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 16px;
      color: rgba(18, 18, 18, 0.5);
    }
    ul {
      display: flex;
      justify-content: space-around;
      margin-top: 53px;
      li {
        width: 220px;
        height: 290px;
        background: #ffffff;
        box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.1);
        padding: 0 30px;
        img {
          margin-top: 30px;
          width: 51px;
          height: 51px;
        }
        h1 {
          margin-top: 30px;
          font-family: PingFang SC, PingFang SC;
          font-weight: 500;
          font-size: 16px;
          color: #252b42;
        }
        p {
          margin-top: 10px;
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 14px;
          color: #737373;
        }
      }
    }
  }
  .box2 {
    // background: url(homeData.background_img) no-repeat center/cover;
    width: 100%;
    height: 502px;
    padding: 60px 0 85px 0;
    h1 {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 30px;
      color: #ffffff;
    }
    p {
      margin-top: 20px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 16px;
      color: #ffffff;
    }
    .database {
      margin-top: 45px;
      width: 100%;
      height: 164px;
      background: #ffffff;
      box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.08);
      border-radius: 0px 0px 0px 0px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      ul {
        display: flex;
        flex-direction: column;
        li {
          display: flex;
          justify-content: center;
          align-items: flex-end;
          h2 {
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 45px;
            color: #175dc2;
            margin: 0;
          }
          p {
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 16px;
            color: #175dc2;
            margin-top: 0;
          }
        }
        span {
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 14px;
          color: rgba(28, 29, 37, 0.5);
        }
      }
    }
  }
}
</style>
